import './utilities/fly-in-panel';

import { h } from '@atomify/jsx';
import { ButtonA } from '@atoms/button/button';
import { ButtonRound } from '@source/components/atoms/button-round/button-round';
import { closeFlyin } from '@source/store/flyins';

interface FlyinInterface {
    id: string;
    label: string | Text;
    buttonLabel?: string | Text;
    buttonLink?: string;
    children?: NodeList;
    onClose?: () => void;
}

export const Flyin = (data: FlyinInterface) => {
    const close = () => {
        data.onClose && data.onClose();
        closeFlyin(data.id);
    };

    return (
        <bpd-fly-in-panel id={data.id} class="c-fly-in">
            <div class="fly-in__header">
                {data.label && <h5>{data.label}</h5>}
                <ButtonRound
                    classes="fly-in__close-button"
                    variant="dark"
                    size="small"
                    svg="icons-close"
                    ariaLabel="Sluit flyin panel"
                    onClick={close}
                />
            </div>

            <div class="fly-in__scroll-container">{data.children}</div>

            {data.buttonLabel && data.buttonLink && (
                <ButtonA label={data.buttonLabel} url={data.buttonLink} classes="fly-in__link" />
            )}
        </bpd-fly-in-panel>
    );
};
